import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Heading, Section } from '../../../shared/ui';

const resolveButtonComponent = (action) => {
  if (!action?.href) {
    return 'button';
  }
  return action.href.startsWith('/') ? Link : 'a';
};

const HeroSection = ({ eyebrow, title, lead, primaryAction, secondaryAction }) => {
  return (
    <Section className="yowan-hero-section">
      <div className="yowan-hero-section__inner">
        <Heading eyebrow={eyebrow} as="h1">
          {title}
        </Heading>
        <p className="yowan-hero-section__lead">{lead}</p>
        <div className="u-inline-links">
          {primaryAction ? (
            <Button
              as={resolveButtonComponent(primaryAction)}
              {...(primaryAction.href.startsWith('/') ? { to: primaryAction.href } : { href: primaryAction.href })}
              variant="primary"
            >
              {primaryAction.label}
            </Button>
          ) : null}
          {secondaryAction ? (
            <Button
              as={resolveButtonComponent(secondaryAction)}
              {...(secondaryAction.href.startsWith('/') ? { to: secondaryAction.href } : { href: secondaryAction.href })}
              variant="secondary"
            >
              {secondaryAction.label}
            </Button>
          ) : null}
        </div>
      </div>
    </Section>
  );
};

export default HeroSection;
